import React, { useEffect, useState } from 'react';
import MakeDataTable from '../../../components/admin/make/VehicleMakeTable';
import { Button } from 'react-bootstrap';
import MakeAddEditModal from '../../../components/admin/make/MakeAddEditModal';

const MakeDashboard: React.FC = () => {
    const [show, setShow] = useState(false);
    const [countAddEdit, setCountAddEdit] = useState(0)
    const [totalRows, setTotalRows] = useState(0)
    const [makeDetails, setMakeDetails] = useState({ id: 0, name: '', keyName: '', logo: '' });
    const newMake = () => {
        setShow(true);
        setMakeDetails({ id: 0, name: '', keyName: '', logo: '' })
    }
    const handleClose = () => setShow(false);

    const editModal = (make: any) => {
        setMakeDetails(make)
        setShow(true)
    }

    return (
        <div id="wrapper">

            <div id="content-wrapper" className="d-flex flex-column">
                {/* Main Content */}
                <div id="content">
                    {/* Topbar */}

                    <div className="container-fluid">
                        <div>
                            <MakeDataTable newMake={newMake} showModal={editModal} handleClose={handleClose} countAddEdit={countAddEdit} totalRows={totalRows} setTotalRows={setTotalRows} />
                            <MakeAddEditModal show={show} handleClose={handleClose} makeDetails={makeDetails} setCountAddEdit={setCountAddEdit} totalRows={totalRows} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MakeDashboard;